export class Orderinfo
{
    public OrderID:string = '';
    public CustomerID:string = '';
    public UnitID:string = '';
    public ClientID:string = '';
    public Name:string = '';
    public Description:string = '';
    public Summary:string = '';
    public Timestamp:number = 0;
    public Status:number = 0;
    public StatusString:string = '';

    public get OrderTimeString()
    {
        var dateTime = new Date(this.Timestamp * 1000);

        var dateTimeNow = new Date();

        if (dateTime.getFullYear() == dateTimeNow.getFullYear() && dateTime.getMonth() == dateTimeNow.getMonth() &&  dateTime.getDate() == dateTimeNow.getDate())
            return dateTime.toLocaleTimeString(undefined , { hour: '2-digit', minute: '2-digit' });
        else
        return dateTime.toLocaleDateString() + ' - ' + dateTime.toLocaleTimeString(undefined , { hour: '2-digit', minute: '2-digit' });
    }
}
